import { Injectable } from '@angular/core';
import { Router, Resolve, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { Execution } from './execution';
import { ExecutionService } from './execution.service';
import { lookupParam } from '../nav/utils';

@Injectable()
export class ExecutionResolver implements Resolve<Execution> {

  constructor(
    private router: Router,
    private executionService: ExecutionService
  ) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Execution | Observable<Execution> | Promise<Execution> {
    return new Promise<Execution>(async (resolve, reject) => {

      let execution_id = lookupParam(route, 'execution_id');

      this.executionService
        .execution(execution_id)
        .subscribe((execution) => {
          
          if(execution) {
            return resolve(execution);
          }
          else {
            this.router.navigateByUrl('/');
            return resolve(null);
          }
        });
    });
  }
}